// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_4BJ","cls2":"ActiveState-cls2_p_w ActiveState-cls1_4BJ","isDisabled":"ActiveState-isDisabled_b07"};